/**
 * Seiten-Identitaet fuers Heatmap-Bucketing. `pageKey` gruppiert nach Seite,
 * `layoutHash` nach grober Layout-Version: der Hash kippt bei Redesign oder
 * verschobenen Bloecken, NICHT bei dynamischen Klassen/Inhalten. Neuer Hash =
 * neuer Bucket, damit Klicks aus „v1" nicht ueber „v2" gemittelt werden.
 */

/** Normalisierter Seiten-Key: pathname ohne Query/Hash/trailing slash. */
export function pageKey(): string {
  if (typeof location === "undefined") return "/";
  return location.pathname.replace(/\/+$/, "") || "/";
}

/**
 * Grober DOM-Struktur-Hash: nur Tag-Namen der Layout-Ebene (tiefenbegrenzt),
 * KEINE Klassen/IDs/Texte. djb2, abhaengigkeitsfrei.
 */
export function layoutHash(maxNodes = 400): string {
  if (typeof document === "undefined" || !document.body) return "0";
  const tags: string[] = [];
  const walk = (el: Element, depth: number): void => {
    if (depth > 6 || tags.length >= maxNodes) return;
    tags.push(depth + el.tagName);
    const kids = el.children;
    for (let i = 0; i < kids.length; i++) walk(kids[i]!, depth + 1);
  };
  try {
    walk(document.body, 0);
  } catch {
    /* noop */
  }
  const s = tags.join(">");
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  return (h >>> 0).toString(36);
}
